import { inject, Injectable } from '@angular/core';
import {
  LEGACY_OFFLINE_STORAGE_KEY,
  OldFrontendFormDataStorageService,
} from '@app/shared/old-frontend/data-access';
import { IApiNextLocationCheckInCreateDto } from '@fmnts/api/next';
import { LOCAL_STORAGE, webStorageItemAccessor } from '@fmnts/common/storage';
import { LocationOfflineStored } from './+state/next-locations.reducer';

@Injectable({ providedIn: 'root' })
export class NextLocationsOfflineStoreService {
  private readonly _storage = webStorageItemAccessor({
    storage: inject(LOCAL_STORAGE),
    key: LEGACY_OFFLINE_STORAGE_KEY,
    defaultState: {},
  });

  private ofFormDataStorage = inject(OldFrontendFormDataStorageService);

  /**
   * Persists a location check in.
   *
   * @param checkIn Check In DTO
   */
  public persistCheckIn(checkIn: IApiNextLocationCheckInCreateDto) {
    const key = this.ofFormDataStorage.createKey(
      checkIn.fundraiser,
      'locationselect',
      new Date(checkIn.createtime),
    );

    this._storage.patch(key, checkIn);
  }

  public removePersistedCheckIn(storeKey: string): void {
    this._storage.remove(storeKey);
  }

  /**
   *
   * @param storedDatasetKey
   * @returns
   */
  public hydrateViewId(
    storedDatasetKey: string,
  ): IApiNextLocationCheckInCreateDto {
    return this._storage.get(storedDatasetKey);
  }

  public hydrate(): LocationOfflineStored[] {
    const keys = Object.keys(this._storage.get());
    const locations: LocationOfflineStored[] = [];

    for (const key of keys) {
      const {
        id,
        category: type,
        timestamp,
      } = this.ofFormDataStorage.parseKey(key);
      const payload = this.hydrateViewId(key);
      if (!id || !type || !timestamp || !payload) {
        continue;
      }

      if (type === 'locationselect') {
        locations.push({
          id,
          category: type,
          timestamp: `${timestamp}`,
          payload,
        });
      }
    }

    return locations;
  }
}
